




import {Component,} from "vue-property-decorator";
import {BaseList} from "@/core/components/BaseList";
import Dashboard from "@/components/Admin/Dashboard/Dashboard.vue";
@Component({
    components: {Dashboard}
})
export default class Welcome extends BaseList {

    public created() {
        super.created();
    }

    public mounted() {
        super.mounted();
    }

}
